import { FullScreenController } from './embed.v4.fullscreen';
import { GuideData } from './embed.v4.data';
import { StepSwitcherImmediate } from './embed.v4.step_switcher';
import { TitleController } from './embed.v4.title';
import { ConclusionController } from './embed.v4.conclusion';
import { IntroController } from './embed.v4.intro';
import { PrepareEmbed } from './embed.v4.prepare';
import { StepsController } from './embed.v4.steps';
import { Zoom } from './embed.v4.zoom';

new TitleController(
   StepsController(
      GuideData,
      StepSwitcherImmediate(),
      IntroController(GuideData, FullScreenController, PrepareEmbed),
      FullScreenController,
      ConclusionController(FullScreenController, PrepareEmbed),
      PrepareEmbed,
      Zoom
   )
);
